/**
 * @generated SignedSource<<755e94d0b6c4baffc421e705343479a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamMemberRole = "Admin" | "Member" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type WebSettingsTeamSettingsRelayQuery$variables = {
  orgRelayId: string;
  teamId: string;
};
export type WebSettingsTeamSettingsRelayQuery$data = {
  readonly org: {
    readonly id?: string;
    readonly primaryOrgCalendar?: string;
    readonly primaryOrgEmail?: string;
    readonly workingGroups?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly calendarIds: ReadonlyArray<string | null> | null;
        } | null;
      } | null> | null;
    };
    readonly primaryTeam?: {
      readonly __typename: "Team";
      readonly teamId: string;
      readonly teamName: string;
    } | {
      readonly __typename: "GraphEntityError";
      readonly statusCode: number | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly userTeams?: {
      readonly __typename: "TeamList";
      readonly list: ReadonlyArray<{
        readonly teamId: string;
        readonly id: string;
        readonly teamName: string;
        readonly createdBy: {
          readonly type: UrnType | null;
          readonly value: string | null;
        };
        readonly teamCalendarId: string | null;
        readonly settings: {
          readonly __typename: "TeamSettings";
          readonly m365TeamCalendarDetails: {
            readonly __typename: "TeamCalendarDetails";
            readonly calendarName: string;
            readonly owner: {
              readonly personId: string;
              readonly primaryCalendarId: string;
            };
          } | {
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        } | {
          readonly __typename: "GraphEntityError";
          readonly message: string | null;
          readonly statusCode: number | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly userSettings: {
          readonly __typename: "TeamUserSettings";
          readonly useTeamCalendar: boolean;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly teamMembers: ReadonlyArray<{
          readonly role: TeamMemberRole;
          readonly person: {
            readonly __typename: string;
            readonly id: string;
            readonly userId: string | null;
            readonly personId: string;
            readonly primaryCalendarId: string;
            readonly calendarAliases: ReadonlyArray<string>;
            readonly isYou: boolean;
            readonly redirectPersonId: string | null;
            readonly profile: {
              readonly givenName: string | null;
              readonly familyName: string | null;
              readonly externalImageUrl: string | null;
            } | null;
          };
        }>;
        readonly invitedMembers: ReadonlyArray<{
          readonly role: TeamMemberRole;
          readonly person: {
            readonly userId: string | null;
            readonly personId: string;
            readonly primaryCalendarId: string;
            readonly calendarAliases: ReadonlyArray<string>;
            readonly isYou: boolean;
            readonly redirectPersonId: string | null;
            readonly profile: {
              readonly givenName: string | null;
              readonly familyName: string | null;
              readonly externalImageUrl: string | null;
            } | null;
          };
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"TeamSettingsAdminTeamCalendar_team" | "TeamSettingsAdminSlack_team">;
      }>;
    } | {
      readonly __typename: "GraphEntityError";
      readonly statusCode: number | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly billingGroups?: {
      readonly list?: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly syncSources: ReadonlyArray<{
          readonly type: UrnType | null;
          readonly value: string | null;
        }>;
      }>;
      readonly message?: string | null;
      readonly statusCode?: number | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"TeamSettingsAdminTeamCalendar_org" | "TeamSettingsAdminSlack_org">;
  } | null;
};
export type WebSettingsTeamSettingsRelayQuery = {
  variables: WebSettingsTeamSettingsRelayQuery$variables;
  response: WebSettingsTeamSettingsRelayQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgRelayId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryOrgCalendar",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryOrgEmail",
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarIds",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "type": "Team",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusCode",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v17 = [
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamCalendarId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryCalendarId",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v12/*: any*/)
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "useTeamCalendar",
      "storageKey": null
    }
  ],
  "type": "TeamUserSettings",
  "abstractKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "calendarAliases",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isYou",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redirectPersonId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "givenName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "familyName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v30/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalImageUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = [
  (v15/*: any*/),
  (v16/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WebSettingsTeamSettingsRelayQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v2/*: any*/),
                "kind": "FragmentSpread",
                "name": "TeamSettingsAdminTeamCalendar_org"
              },
              {
                "args": (v2/*: any*/),
                "kind": "FragmentSpread",
                "name": "TeamSettingsAdminSlack_org"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "WorkingGroupConnection",
                "kind": "LinkedField",
                "name": "workingGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkingGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workingGroups(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "TeamSettingsAdminTeamCalendar_team"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "TeamSettingsAdminSlack_team"
                          },
                          (v9/*: any*/),
                          (v3/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "m365TeamCalendarDetails",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v19/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgPerson",
                                            "kind": "LinkedField",
                                            "name": "owner",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TeamCalendarDetails",
                                        "abstractKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamSettings",
                                "abstractKey": null
                              },
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "userSettings",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMembers",
                            "plural": true,
                            "selections": [
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgPerson",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v3/*: any*/),
                                  (v25/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "invitedMembers",
                            "plural": true,
                            "selections": [
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgPerson",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamList",
                    "abstractKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingGroup",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "syncSources",
                            "plural": true,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "BillingGroupList",
                    "abstractKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WebSettingsTeamSettingsRelayQuery",
    "selections": [
      {
        "alias": "org",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "teamSettings",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manageTeamCalendar",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "syncWFHEvents",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minimumMinutesForSyncing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSlackSettings",
                        "kind": "LinkedField",
                        "name": "slackSettings",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notificationEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "channelId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timeSlot",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "channelName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "m365TeamCalendarDetails",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamCalendarMember",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgPerson",
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v27/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UserProfile",
                                    "kind": "LinkedField",
                                    "name": "profile",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v30/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TeamCalendarDetails",
                            "abstractKey": null
                          },
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamSettings",
                    "abstractKey": null
                  },
                  (v14/*: any*/),
                  (v33/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "slackAccountForTeamErrorable",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v22/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slackUserId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slackTeamId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "teamDisplayName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "needsUpdate",
                        "storageKey": null
                      }
                    ],
                    "type": "SlackAccount",
                    "abstractKey": null
                  },
                  (v33/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "WorkingGroupConnection",
                "kind": "LinkedField",
                "name": "workingGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkingGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workingGroups(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v14/*: any*/),
                  (v33/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMembers",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgPerson",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/),
                                  (v3/*: any*/),
                                  (v25/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v27/*: any*/),
                                  (v31/*: any*/),
                                  (v26/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v24/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v34/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "m365TeamCalendarDetails",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v19/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgPerson",
                                            "kind": "LinkedField",
                                            "name": "owner",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v21/*: any*/),
                                              (v3/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "TeamCalendarDetails",
                                        "abstractKey": null
                                      },
                                      (v14/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamSettings",
                                "abstractKey": null
                              },
                              (v22/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "userSettings",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v23/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "invitedMembers",
                            "plural": true,
                            "selections": [
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgPerson",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v31/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamList",
                    "abstractKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingGroup",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "syncSources",
                            "plural": true,
                            "selections": (v34/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "BillingGroupList",
                    "abstractKey": null
                  },
                  (v22/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "49f9d24a6ccf3440452e66aca310d18c",
    "id": null,
    "metadata": {},
    "name": "WebSettingsTeamSettingsRelayQuery",
    "operationKind": "query",
    "text": "query WebSettingsTeamSettingsRelayQuery(\n  $orgRelayId: ID!\n  $teamId: String!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...TeamSettingsAdminTeamCalendar_org_1j7Wr3\n      ...TeamSettingsAdminSlack_org_1j7Wr3\n      id\n      primaryOrgCalendar\n      primaryOrgEmail\n      workingGroups(first: 1000000) {\n        edges {\n          node {\n            calendarIds\n            id\n          }\n        }\n      }\n      primaryTeam {\n        __typename\n        ... on Team {\n          teamId\n          teamName\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      userTeams {\n        __typename\n        ... on TeamList {\n          list {\n            ...TeamSettingsAdminTeamCalendar_team\n            ...TeamSettingsAdminSlack_team\n            teamId\n            id\n            teamName\n            createdBy {\n              type\n              value\n              id\n            }\n            teamCalendarId\n            settings {\n              __typename\n              ... on TeamSettings {\n                m365TeamCalendarDetails {\n                  __typename\n                  ... on TeamCalendarDetails {\n                    calendarName\n                    owner {\n                      personId\n                      primaryCalendarId\n                      id\n                    }\n                  }\n                  ... on GraphEntityError {\n                    statusCode\n                    message\n                  }\n                }\n              }\n              ... on GraphEntityError {\n                message\n                statusCode\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            userSettings {\n              __typename\n              ... on TeamUserSettings {\n                useTeamCalendar\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            teamMembers {\n              role\n              person {\n                __typename\n                id\n                userId\n                personId\n                primaryCalendarId\n                calendarAliases\n                isYou\n                redirectPersonId\n                profile {\n                  givenName\n                  familyName\n                  externalImageUrl\n                }\n              }\n            }\n            invitedMembers {\n              role\n              person {\n                userId\n                personId\n                primaryCalendarId\n                calendarAliases\n                isYou\n                redirectPersonId\n                profile {\n                  givenName\n                  familyName\n                  externalImageUrl\n                }\n                id\n              }\n            }\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n      }\n      billingGroups {\n        __typename\n        ... on BillingGroupList {\n          list {\n            id\n            name\n            syncSources {\n              type\n              value\n              id\n            }\n          }\n        }\n        ... on GraphEntityError {\n          message\n          statusCode\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment TeamSettingsAdminSlack_org_1j7Wr3 on Org {\n  id\n  experiments\n  teamSettings(teamId: $teamId) {\n    __typename\n    ... on TeamSettings {\n      manageTeamCalendar\n      slackSettings {\n        notificationEnabled\n        channelId\n        channelName\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  slackAccountForTeamErrorable(teamId: $teamId) {\n    __typename\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on SlackAccount {\n      slackUserId\n      slackTeamId\n      teamDisplayName\n      needsUpdate\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment TeamSettingsAdminSlack_team on Team {\n  id\n  teamId\n  teamName\n  teamCalendarId\n}\n\nfragment TeamSettingsAdminTeamCalendar_org_1j7Wr3 on Org {\n  id\n  experiments\n  teamSettings(teamId: $teamId) {\n    __typename\n    ... on TeamSettings {\n      manageTeamCalendar\n      syncWFHEvents\n      minimumMinutesForSyncing\n      slackSettings {\n        notificationEnabled\n        channelId\n        timeSlot\n      }\n      m365TeamCalendarDetails {\n        __typename\n        ... on TeamCalendarDetails {\n          calendarName\n          members {\n            status\n            personId\n          }\n          owner {\n            personId\n            primaryCalendarId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment TeamSettingsAdminTeamCalendar_team on Team {\n  id\n  teamId\n  teamName\n  teamCalendarId\n  teamMembers {\n    person {\n      __typename\n      id\n      userId\n      personId\n      primaryCalendarId\n      isYou\n      profile {\n        givenName\n        familyName\n        externalImageUrl\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7835193cb3c321810106235704ab602b";

export default node;
